import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const solutionsPathMap = localizePathMap({
	[Locale.cs]: "nase-reseni",
	[Locale.en]: "our-solutions",
});
